const zh = {
  // Header
  nav_home: '首页',
  nav_booking: '立即预约',
  nav_therapists: '理疗师',
  menu_label: '菜单',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: '体验泰国顶级\n按摩服务',
  hero_subtitle: '在芭提雅、普吉岛、曼谷和呵叻预约专业理疗师的高端按摩服务',
  hero_book_now: '立即预约',
  hero_view_therapists: '查看理疗师',
  stat_therapists: '专业理疗师',
  stat_locations: '服务地区',
  stat_rating: '平均评分',

  // Features
  feature_gps_title: 'GPS自动定位',
  feature_gps_desc: '自动为您找到距离最近的服务地区',
  feature_booking_title: '便捷预约',
  feature_booking_desc: '只需5步即可轻松预约按摩服务',
  feature_verified_title: '认证理疗师',
  feature_verified_desc: '经验丰富、评价验证的专业理疗师',

  // Nearby therapists section
  nearby_title: '您附近的理疗师',
  nearby_subtitle: '根据GPS位置推荐最近的理疗师',
  nearby_loading: '正在检测您的位置...',
  nearby_error: '无法检测您的位置',
  nearby_retry: '重试',
  nearby_distance: '距离{distance}km',
  nearby_book: '立即预约',

  // Locations section
  section_locations_title: '可预约地区',
  section_locations_subtitle: '我们在泰国5个主要城市提供服务',
  loc_book: '立即预约',

  // Courses section
  section_courses_title: '按摩课程',
  section_courses_subtitle: '探索我们丰富的按摩项目',

  // Therapists section
  section_therapists_title: '人气理疗师',
  section_therapists_subtitle: '为您介绍评分最高的理疗师',
  view_all_therapists: '查看全部理疗师',

  // CTA
  cta_title: '立即预约',
  cta_subtitle: '最佳泰式按摩体验等待着您',
  cta_book: '立即预约',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. All rights reserved.',

  // Booking Steps
  step_location: '选择地区',
  step_course: '选择课程',
  step_therapist: '理疗师',
  step_datetime: '日期/时间',
  step_confirm: '确认',

  // Booking - Step 1
  booking_location_title: '请选择地区',
  booking_location_desc: '请选择您想接受按摩的地区',
  gps_detect: '自动定位当前位置',
  gps_loading: '正在定位...',

  // Booking - Step 2
  booking_course_title: '请选择按摩课程',
  booking_course_desc: '请选择您想要的按摩类型和时长',
  duration_min: '{min}分钟',

  // Booking - Step 3
  booking_therapist_title: '请选择理疗师',
  booking_therapist_desc: '在{location}服务的理疗师',
  no_therapist: '没有符合所选地区和课程的理疗师。',
  no_therapist_suggest: '请尝试选择其他课程。',

  // Booking - Step 4
  booking_datetime_title: '请选择日期和时间',
  booking_datetime_desc: '请选择您想预约的日期和时间',
  date_select: '选择日期',
  time_select: '选择时间',
  time_placeholder: '请先选择日期',
  time_notice: '根据距离，理疗师到达可能需要最多2小时。请选择充裕的时间。',

  // Booking - Step 5
  booking_confirm_title: '请确认预约信息',
  booking_confirm_desc: '请确认所有信息并输入联系方式',
  summary_location: '地区',
  summary_course: '课程',
  summary_price: '价格',
  summary_therapist: '理疗师',
  summary_date: '日期',
  summary_time: '时间',
  health_check_title: '健康状况确认',
  health_check_desc: '如有健康问题、疼痛部位或希望避开按摩的部位，请告知我们。',
  health_check_placeholder: '例如：我有高血压 / 右肩受伤，上半身请轻一些 / 腰椎间盘突出，请跳过腰部',
  health_check_examples: '例如：我有高血压 / 右肩受伤，上半身请轻一些 / 腰椎间盘突出，请跳过腰部',
  contact_title: '联系方式',
  contact_name: '姓名',
  contact_name_placeholder: '请输入您的姓名',
  contact_phone: '电话号码',
  contact_phone_placeholder: '请输入您的电话号码',
  contact_email: '电子邮箱',
  contact_email_placeholder: '请输入您的电子邮箱',
  contact_note: '特殊要求',
  contact_note_placeholder: '如有特殊要求请在此输入',
  required_mark: '*',

  // Navigation buttons
  btn_prev: '上一步',
  btn_next: '下一步',
  btn_complete: '完成预约',

  // Therapist card
  age_suffix: '岁',
  experience_years: '{years}年经验',

  // Therapist list page
  tl_title: '理疗师',
  tl_subtitle: '与经验丰富、专业认证的顶级理疗师见面',
  tab_all: '全部',

  // Confirmation page
  conf_empty_title: '没有预约信息',
  conf_empty_desc: '请从预约页面进行预约。',
  conf_empty_btn: '立即预约',
  conf_success_title: '预约成功！',
  conf_success_subtitle: '您的预约信息已确认。谢谢。',
  conf_preparation_title: '预约未接收',
  conf_preparation_subtitle: '目前服务正在筹备中，预约尚未确认。正式上线后我们将与您联系。',
  conf_preparation_notice: '服务正在筹备中，此预约并非已确认的预订。',
  conf_booking_id: '预约编号',
  conf_detail_title: '预约详情',
  conf_label_location: '地区',
  conf_label_course: '按摩课程',
  conf_label_price: '价格',
  conf_label_therapist: '理疗师',
  conf_label_date: '日期',
  conf_label_time: '时间',
  conf_label_email: '电子邮箱',
  conf_label_contact: '联系方式',
  conf_label_note: '特殊要求',
  conf_notice_title: '注意事项',
  conf_notice_1: '根据距离，理疗师到达可能需要最多2小时。',
  conf_notice_2: '如需更改或取消预约，请电话联系我们。',
  conf_notice_3: '可在现场使用现金或银行卡支付。',
  conf_btn_home: '返回首页',
  conf_btn_new: '新预约',

  // Geolocation errors
  GEO_NOT_SUPPORTED: '您的浏览器不支持GPS定位。',
  GEO_PERMISSION_DENIED: '位置访问被拒绝。请手动选择地区。',
  GEO_POSITION_UNAVAILABLE: '无法获取位置信息。',
  GEO_TIMEOUT: '位置请求超时。',
  GEO_UNKNOWN: '发生未知错误。',

  // SEO
  seo_home_title: '曼谷上门按摩预约 | Bangkok In Home Massage',
  seo_home_desc: '认证按摩师上门到曼谷、芭提雅、普吉岛、清迈、呵叻的酒店或住所。泰式传统、精油、芳疗按摩在线轻松预约。',
  seo_therapists_title: '上门按摩理疗师 | Bangkok In Home Massage',
  seo_therapists_desc: '浏览曼谷、芭提雅、普吉岛、清迈、呵叻的认证按摩师。查看个人资料、评分和专业领域，立即在线预约。',
  seo_booking_title: '在线预约上门按摩 | Bangkok In Home Massage',
  seo_booking_desc: '选择地区、按摩类型和理疗师，在线预约上门按摩。专业按摩师到您的酒店或住所提供服务。',

  // Body info
  height_label: '身高',
  weight_label: '体重',

  // GPS therapist list
  gps_find_nearby: '查找附近的理疗师',
  gps_nearby_active: '按距离排序显示中',

  // Notices
  notice_punctual: '理疗师将按您预约的日期和时间准时到达。请提前做好准备。',
  notice_no_sexual: '本服务为专业按摩服务。严禁提供任何性服务。',

  // Guide section
  guide_title: '服务指南',
  guide_subtitle: '为了更舒适的体验，请阅读以下信息',
  guide_before_title: '服务前须知',
  guide_before_text: '建议在服务前简单淋浴。请避免饭后立即预约，醉酒状态下可能会被拒绝服务。如有基础疾病（高血压、心脏病等）或怀孕，请在预约时在特殊要求中提前说明。',
  guide_booking_title: '预约须知',
  guide_booking_text: '根据距离，理疗师到达可能需要最多2小时，请选择充裕的时间。如需更改或取消预约，请电话联系我们。',
  guide_session_title: '服务中须知',
  guide_session_text: '理疗师将按预约时间前往您的住所。如在服务过程中感到不适，请立即告知理疗师。本服务为专业按摩服务，严禁提供任何性服务。',
  guide_after_title: '服务后须知',
  guide_after_text: '请多喝水。暂时的肌肉酸痛或疲劳属正常现象，2~3天内会恢复。当天请避免过量饮酒和剧烈运动。',
  guide_payment_title: '支付方式',
  guide_payment_text: '可在现场使用现金或银行卡支付。',

  // FAQ
  faq_q1: '上门按摩如何使用？',
  faq_a1: '选择地区，选择按摩类型，挑选理疗师，预约日期和时间。理疗师将前往您的酒店或住所。',
  faq_q2: '哪些地区可以使用服务？',
  faq_a2: '我们在曼谷、芭提雅、普吉岛、清迈和呵叻5个地区提供专业上门按摩服务。',
  faq_q3: '如何更改或取消预约？',
  faq_a3: '如需更改或取消预约，请电话联系我们。可在现场使用现金或银行卡支付。',

  // 404
  notfound_title: '页面未找到',
  notfound_desc: '您请求的页面不存在或已被移动。',
  notfound_home: '返回首页',
};

export default zh;
